import { SearchRegistry } from '../types';

export const integrationAndSettingsSearchEntries: SearchRegistry = {
  '/integration-and-settings/onboarding': {
    keywords: [
      'onboarding',
      'getting started',
      'onboarding status',
      'api access',
      'api credentials access',
      'docs access',
      'documentation access',
      'where to find',
      'integration checklist',
      'partner onboarding',
      'api partner onboarding',
      'getting started guide',
    ],
    questions: [
      'How do I get started as an API partner?',
      'What is my onboarding status?',
      'Where do I find my API access and credentials?',
      'How do I get access to the integration documentation?',
    ],
  },
  '/integration-and-settings/overview': {
    keywords: [
      'integration settings',
      'integration settings overview',
      'partner self-service',
      'partner integration',
      'integration hub',
      'integration overview',
    ],
    questions: [
      'Where do I find integration settings?',
      'What partner self-service tools are available?',
      'How do I jump to API Credentials, UI Customization, Data Validation, or Fraud Rules?',
    ],
  },
  '/integration-and-settings/api-credentials': {
    keywords: [
      'api credentials',
      'api keys',
      'partner api credentials',
      'client id',
      'client secret',
      'rotate credentials',
      'create api key',
      'auth credentials',
      'api credentials admin',
      'fleet api credentials',
      'oauth2 client credentials',
      'rsa public key',
      'rsa key pair',
      'generate key pair',
      'staging credentials',
      'production credentials',
      'api credentials management',
      'api_credentials_admin',
      'partner api authentication',
    ],
    questions: [
      'How do I get my API credentials?',
      'Where do I rotate my API client secret?',
      'How do I generate a new API key?',
      'How do I upload an RSA public key for JWT assertion?',
      'Why can I see credentials but not edit them?',
    ],
    faqs: [
      {
        q: 'How do I rotate my API client secret?',
        a: 'Open Integration Settings → API Credentials. Use Generate New Secret to issue a fresh secret; the previous one stays valid for a short overlap window so you can roll it out without downtime, then revoke the old one.',
      },
      {
        q: 'I can view API Credentials but the Manage actions are disabled — why?',
        a: 'Managing credentials (create, regenerate, upload key pair) requires the `api_credentials_admin` role. Users without it can review staging and production credentials but cannot mutate them. Ask a partner admin to grant the role.',
      },
      {
        q: 'Where do I generate an RSA key pair for JWT assertion?',
        a: 'On API Credentials → Generate Key Pair. The page produces a public/private RSA key pair; upload the public key here and keep the private key in your backend to sign JWT assertions for the Fleet API and ryd Connect.',
      },
    ],
  },
  '/integration-and-settings/ui-settings': {
    keywords: [
      'ui customization',
      'ui settings',
      'theming',
      'partner branding',
      'colors',
      'logo',
      'custom theme',
      'white label',
      'partner ui',
      'theme preview',
      'theme palette',
      'theme tokens',
      'css variables theme',
      'ui customization page',
    ],
    questions: [
      'How do I customise the UI for my partner?',
      'Where do I configure my brand colors and logo?',
      'How do I change the theming on hosted ryd surfaces?',
      'How do I preview my partner theme before publishing?',
    ],
  },
  '/integration-and-settings/data-validation': {
    keywords: [
      'data validation',
      'mandatory fields',
      'partner data validation',
      'required fields',
      'jwt mandatory fields',
      'ryd connect mandatory fields',
      'enforce request fields',
      'partner data validation page',
      'partnerDataValidation',
    ],
    questions: [
      'How do I require a field on every ryd Connect session?',
      'Where do I configure mandatory fields per environment?',
      'How are mandatory fields enforced in fleet APIs?',
    ],
    faqs: [
      {
        q: 'Where do mandatory field names come from?',
        a: 'They mirror the JWT claim paths used in the ryd Connect launch token (for example userData.firstName, vehicleData.licensePlate, partnerOrderId). See the ryd Connect partner extra data guide for the full payload structure.',
      },
    ],
  },
  '/integration-and-settings/fraud-rules': {
    keywords: [
      'fraud rules',
      'fraud protection',
      'partner fraud rules',
      'order limits',
      'max orders per timeframe',
      'orderStatus',
      'rolling window',
      'fraud validation',
      'partnerFraudRules',
    ],
    questions: [
      'How do I limit how many orders a user can place per hour?',
      'Where do I test fraud rules against a partner user?',
      'How do I configure fraud rules per environment?',
    ],
    faqs: [
      {
        q: 'What does the validate panel do?',
        a: 'It calls the fleet-service validate endpoint with a partner user ID and returns whether the user is currently within the configured limits — a fast way to confirm a rule behaves as expected before exposing it to live traffic.',
      },
    ],
  },
};
